import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CrawfordSpinnerService, CrawfordTabComponent, ITabComponent, TabItem, TabItemHeader } from 'crawford-shell';
import { UserDetails } from '../../user/user-details.model';
import { UserService } from '../../user/user.service';
import { BaseSearchListComponent } from '../base-search-list.component';


@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss']
})
export class SearchListComponent implements OnInit {

  @ViewChild('tabCollection') public tabCollection: CrawfordTabComponent;
  @ViewChild('currentUserSearchesTab') public currentUserSearchesTab: BaseSearchListComponent;
  @ViewChild('allUsersSearchesTab') public allUsersSearchesTab: BaseSearchListComponent;

  public formBuilder: FormBuilder;
  public searchTabs: TabItem[] = [];
  public tabComponenetsSet: boolean;
  public scrollable = 'Scrollable';

  private userDetails: UserDetails;

  constructor(
    private spinnerService: CrawfordSpinnerService,
    private userService: UserService
  ) {
    this.formBuilder = new FormBuilder();
  }

  ngOnInit() {
    this.userDetails = this.userService.userDetails;
    this.tabComponenetsSet = false;
    this.searchTabs = [
      new TabItem(new TabItemHeader('Mine'), '#currentUserSearchesTab'),
      new TabItem(new TabItemHeader('All Users'), '#allUsersSearchesTab')
    ];
    this.spinnerService.stopPageSpinner();
  }

  public onSelected(event: any) {
    this.setTabs();
  }

  setTabs(): any {
    if (!this.tabComponenetsSet) {
      this.searchTabs[0].component = this.currentUserSearchesTab;
      this.searchTabs[1].component = this.allUsersSearchesTab;
      this.tabComponenetsSet = true;
    }

    if (this.userService.userDetails.userType === 'External') {
      this.tabCollection.hideTab(1);
    } else if (this.userService.userDetails.userType === 'Internal') {
      this.tabCollection.showTab(1);
    }
  }

  onSearchListChanged(): void {
    this.allUsersSearchesTab.refreshGrid();
    this.currentUserSearchesTab.refreshGrid();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/saved-search/search-list/search-list.component.ts